import { render } from "./layout_20230209_2847.vue?vue&type=template&id=3ca7e306&scoped=true"
import script from "./layout_20230209_2847.vue?vue&type=script&lang=js"
export * from "./layout_20230209_2847.vue?vue&type=script&lang=js"

import "./layout_20230209_2847.vue?vue&type=style&index=0&id=3ca7e306&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca7e306"]])

export default __exports__